// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import FlashController from "./flash_controller"
application.register("flash", FlashController)

// import HelloController from "./hello_controller"
// application.register("hello", HelloController)

import SurveyViewerController from "./survey_viewer_controller"
application.register("survey-viewer", SurveyViewerController)

import SurveySwipeController from "./survey_swipe_controller"
application.register("survey-swipe", SurveySwipeController)

import SurveyReorderController from "./survey_reorder_controller"
application.register("survey-reorder", SurveyReorderController)

import SurveyHtmlScalerController from "./survey_html_scaler_controller"
application.register("survey-html-scaler", SurveyHtmlScalerController)

import AdminTabsController from "./admin_tabs_controller"
application.register("admin-tabs", AdminTabsController)

import AdminModalController from "./admin_modal_controller"
application.register("admin-modal", AdminModalController)

import AdminLayoutController from "./admin_layout_controller"
application.register("admin-layout", AdminLayoutController)

import AdminDropdownController from "./admin_dropdown_controller"
application.register("admin-dropdown", AdminDropdownController)

import DarkModeController from "./dark_mode_controller"
application.register("dark-mode", DarkModeController)

import SidebarDropdownController from "./sidebar_dropdown_controller"
application.register("sidebar-dropdown", SidebarDropdownController)

import AdminConfirmSubmitController from "./admin_confirm_submit_controller"
application.register("admin-confirm-submit", AdminConfirmSubmitController)

import AdminFavoriteToggleController from "./admin_favorite_toggle_controller"
application.register("admin-favorite-toggle", AdminFavoriteToggleController)

import AdminFilterFormController from "./admin_filter_form_controller"
application.register("admin-filter-form", AdminFilterFormController)

import AdminScoreHoverController from "./admin_score_hover_controller"
application.register("admin-score-hover", AdminScoreHoverController)

import AdminNotificationController from "./admin_notification_controller"
application.register("admin-notification", AdminNotificationController)

import AdminCheckboxController from "./admin_checkbox_controller"
application.register("admin-checkbox", AdminCheckboxController)

import AdminBulkSelectController from "./admin_bulk_select_controller"
application.register("admin-bulk-select", AdminBulkSelectController)

import AdminRadioController from "./admin_radio_controller"
application.register("admin-radio", AdminRadioController)

import PublicNavController from "./public_nav_controller"
application.register("public-nav", PublicNavController)

import AdminAutoSubmitController from "./admin_auto_submit_controller"
application.register("admin-auto-submit", AdminAutoSubmitController)

import AdminDatepickerController from "./admin_datepicker_controller"
application.register("admin-datepicker", AdminDatepickerController)

import CookieConsentController from "./cookie_consent_controller"
application.register("cookie-consent", CookieConsentController)

import PublicDropdownController from "./public_dropdown_controller"
application.register("public-dropdown", PublicDropdownController)

import ProgressBarController from "./progress_bar_controller"
application.register("progress-bar", ProgressBarController)

import OnboardingUploaderController from "./onboarding_uploader_controller"
application.register("onboarding-uploader", OnboardingUploaderController)

import OnboardingChatScrollController from "./onboarding_chat_scroll_controller"
application.register("onboarding-chat-scroll", OnboardingChatScrollController)
